import {Controller} from "stimulus";
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['form', 'details', 'spinner']

  connect() {
    this.boundSetHeader = this.setHeader.bind(this);
    this.boundShowSpinner = this.showSpinner.bind(this);
    this.boundHideSpinner = this.hideSpinner.bind(this);
    this.boundHideTable = this.hideTable.bind(this);
    this.formTarget.addEventListener('ajax:beforeSend', this.boundSetHeader);
    this.formTarget.addEventListener('ajax:beforeSend', this.boundShowSpinner);
    this.formTarget.addEventListener('ajax:complete', this.boundHideSpinner);
    this.formTarget.addEventListener('ajax:beforeSend', this.boundHideTable);
  }

  setHeader(event) {
    const [xhr, status, data] = event.detail;
    xhr.setRequestHeader('X-Form', 'remote');
  }

  success(event) {
    const [data, status, xhr] = event.detail;
    this.detailsTarget.innerHTML = xhr.response;
    this.showTable();
  }

  showSpinner() {
    this.spinnerTarget.classList.remove('d-none')
  }

  hideSpinner() {
    this.spinnerTarget.classList.add('d-none')
  }

  showTable() {
    this.detailsTarget.classList.remove('opacity-0');
    this.detailsTarget.classList.add('opacity-5');
  }

  hideTable() {
    this.detailsTarget.classList.remove('opacity-5');
    this.detailsTarget.classList.add('opacity-0');
  }

  submit() {
    Rails.fire(this.formTarget, 'submit');
  }

  disconnect() {
    this.formTarget.removeEventListener('ajax:beforeSend', this.boundSetHeader);
    this.formTarget.removeEventListener('ajax:beforeSend', this.boundShowSpinner);
    this.formTarget.removeEventListener('ajax:complete', this.boundHideSpinner);
    this.formTarget.removeEventListener('ajax:beforeSend', this.boundHideTable);
  }
}
